<hb-login-container>
  <div *ngIf="!emptyCatalog" content>
      <p class="text-muted">{{ 'CatalogError.SelectCatalog' | i18next}}</p>
      <hb-catalog-selector [changeAction]="true" (onChanged)="setCatalog($event)" > </hb-catalog-selector>
      <button class="btn btn-primary px-4 pull-right" type="button" (click)="Submit()" >
          <span>Continue</span>
      </button>
  </div>
  <div *ngIf="emptyCatalog" content>
    <p class="text-muted">This User account {{email}} does not have access to any AllAssets Catalogs.</p>
    <p>{{ 'CatalogError.ContactAdmin' | i18next}}</p>
</div>
</hb-login-container>